import { Button, Modal } from 'gwx-voyager-components';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AddressInput from '../../AddressInput/AddressInput.react';

/**
 * Component that represents the address column in the Opportunity Queue table.
 *
 * @class OpportunityQueueAddress
 * @extends {Component}
 */
class OpportunityQueueAddress extends Component {
	constructor(props) {
		super();
		this.generateCheckBoxes = this.generateCheckBoxes.bind(this);
		this.onClickAddAddress = this.onClickAddAddress.bind(this);
		this.confirmDirectAddress = this.confirmDirectAddress.bind(this);
		this.onModalClose = this.onModalClose.bind(this);
		this.createConfirmationContent = this.createConfirmationContent.bind(this);
		this.state = {
			checked: props.checked || {},
			directAddressModal: null,
			confirmationContent: null,
			noDirectAddressFoundStatuses:["NPPES_HPD_ADDRESS_NOT_FOUND","HPD_ENTRY_NOT_FOUND","NPPES_DIRECT_ADDRESS_NOT_FOUND"]
		};
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.setState({ checked: nextProps.checked });
	}

	onClickAddAddress(address, successCallback, errorCallback) {
		this.props.create({
			npi: this.props.providerNpi,
			sendingFacilityId: this.props.sendingFacilityId,
			manualAddress: address,
			demographics: this.props.nppesDemographic,
			providerSubscriptionStatusDocumentId: this.props.providerSubscriptionStatusDocumentId,
			sendingFacilityDisplayName: this.props.sendingFacilityDisplayName,
			providerAtSendingFacility: this.props.providerAtSendingFacility
		}, () => {
			if (successCallback) {
				successCallback();
			}
		}, errorCallback);
	}

	onModalClose(cancelCallback) {
		if (cancelCallback) {
			cancelCallback();
		}
		this.setState({
			directAddressModal: null
		});
	}

	confirmDirectAddress(address, response, successCallback, errorCallback, cancelCallback) {
		const isOptOutAll = response && response.response
			&& response.response.entities && response.response.entities.validateAddress
			&& response.response.entities.validateAddress && response.response.entities.validateAddress[address]
			&& response.response.entities.validateAddress[address].isOptOutAll;
		this.setState({
			directAddressModal: <Modal
				title='Direct Address Confirmation'
				content={this.createConfirmationContent(address, isOptOutAll)}
				show
				onClose={() => this.onModalClose(cancelCallback)}
				closeLabel='Cancel'
				buttons={[
					<Button
						id='direct-address-confirm'
						key='directAddressConfirm'
						className='btn-success'
						onClick={() => {
							this.onClickAddAddress(address, successCallback, errorCallback); this.onModalClose(null);
						}}
					>
						Confirm
					</Button>]}
			/>
		});
	}

	validateAddress(address, successCallback, errorCallback) {
		this.props.validateAddress({
			directAddress: address
		}, (response) => {
			if (successCallback) {
				successCallback(response);
			}
		}, errorCallback);
	}
    
	
	createConfirmationContent(address, isOptOutAll) {
		const displayProviderOrOrganizationName = () => {
			let name='';
			if(this.props.nppesDemographic.organizationName !== null && this.props.nppesDemographic.organizationName!==''){
				name = <dd> {this.props.nppesDemographic.organizationName} </dd>;
			}
			else if(this.props.nppesDemographic.firstName === null && this.props.nppesDemographic.lastName!=null){
				name = <dd> {this.props.nppesDemographic.lastName}</dd> ;
			}
			else if(this.props.nppesDemographic.lastName === null && this.props.nppesDemographic.firstName!=null){
				name =  <dd>{this.props.nppesDemographic.firstName}</dd>
			}
			else{
			  name = <dd>{this.props.nppesDemographic.lastName}, {this.props.nppesDemographic.firstName}</dd>
			}
			return name;
		}
		return (
			<div className='text-justify'>
				{isOptOutAll ? <p className='alert alert-warning text-center'>This address is unsubscribed from all ADT notifications.</p> : null}
				<p>
					Please confirm that you are adding the provider below for Admit/Discharge/Transfer (ADT) notification list for
					{' '}
					<b>{this.props.sendingFacilityDisplayName}</b>
					.
				</p>
				{isOptOutAll
					? <p>Upon your confirmation, this will create an 'Unsubscribed All' subscription.  This provider will not receive notifications until resubscribed.  See resubscribe options in the manage tab.</p>
					: <p>Upon your confirmation, the providers will start to receive a set of ADT notifications for their patients.</p> }

				<dl>
					<dt>Name: </dt>
					 {displayProviderOrOrganizationName()}
					<dt>NPI:</dt>
					<dd>{this.props.providerNpi}</dd>
					<dt>Direct Address:</dt>
					<dd>{address}</dd>
				</dl>
			</div>
		);
	}
   
	/**
	 * A function for mapping direct addresses into an array of checkbox inputs
	 *
	 * @param {Array} directAddresses - An array of direct address objects
	 */
	generateCheckBoxes(directAddresses, nppesDirectAddresses, hpdNppesDirectAddresses, nonTrustedDirectAddresses,nonTrustedNppesDirectAddresses,nonTrustedHpdNppesDirectAddresses) {
		let adtAddressesNotTrusted = [];
		if(this.props.providerSubscriptionStatusDisplay === "INVALID_ADT_DIRECT_ADDRESS"){
			adtAddressesNotTrusted = nonTrustedDirectAddresses;
			directAddresses = [];
			nonTrustedDirectAddresses = [];
		}
		const hpdNppesaddresses = hpdNppesDirectAddresses.map((address) => (
			<div className='checkbox direct-address-checkbox' key={address}>
				<label htmlFor={`option-${address}`}>
					<input
						name={`option-${address}`}
						type='checkbox'
						className='mr-2'
						value={address || ''}
						onChange={(e) => this.props.handleCheck(e, this.props.id, 'nppesHpd')}
						checked={!!(this.state.checked[this.props.id]
							&& this.state.checked[this.props.id]?.['nppesHpd']?.includes(address))}
					/>
					{address + '(NPPES & HPD)'}
				</label>
			</div>
		));
		const source = this.state.noDirectAddressFoundStatuses.includes(this.props.providerSubscriptionStatusDisplay)? '(MANUAL)': '(HPD)';
		const addresses = directAddresses.map((address) => (
			<div className='checkbox direct-address-checkbox' key={address}>
				<label htmlFor={`option-${address}`}>
					<input
						name={`option-${address}`}
						type='checkbox'
						className='mr-2'
						value={address || ''}
						onChange={(e) => this.props.handleCheck(e, this.props.id, source === '(MANUAL)'? 'manual':'hpd')}
						checked={source==='(MANUAL)'? !!(this.state.checked[this.props.id]
							&& this.state.checked[this.props.id]?.['manual']?.includes(address))
						 :!!(this.state.checked[this.props.id]
							&& this.state.checked[this.props.id]?.['hpd']?.includes(address))
						}
					/>
					{address + source}
				</label>
			</div>
		));
		const nppesAddresses = nppesDirectAddresses.map((address) => (
			<div className='checkbox direct-address-checkbox' key={address}>
				<label htmlFor={`option-${address}`}>
					<input
						name={`option-${address}`}
						type='checkbox'
						className='mr-2'
						value={address || ''}
						onChange={(e) => this.props.handleCheck(e, this.props.id, 'nppes')}
						checked={!!(this.state.checked[this.props.id]
							&& this.state.checked[this.props.id]?.['nppes']?.includes(address))}
					/>
					{address + '(NPPES)'}
				</label>
			</div>
		));
		const adtAddresses = adtAddressesNotTrusted?.map((address) => (
			<div className='checkbox direct-address-checkbox' key={address}>
				<label htmlFor={`option-${address}`} className='non-trusted'>
					<input
						name={`option-${address}`}
						type='checkbox'
						className='mr-2'
						disabled='true'
						value={address || ''}
					/>
					{'(Not trusted) ' + address + ' (ADT)'}
				</label>
			</div>
		));
		const nonTrustedHpdNppesAddress = nonTrustedHpdNppesDirectAddresses?.map((address) => (
			<div className='checkbox direct-address-checkbox' key={address}>
				<label htmlFor={`option-${address}`} className='non-trusted'>
					<input
						name={`option-${address}`}
						type='checkbox'
						className='mr-2'
						value={address || ''}
						disabled='true'
					/>
					{'(Not Trusted)' + address + '(NPPES & HPD)'}
				</label>
			</div>
		));
		const nonTrustedAddresses = nonTrustedDirectAddresses?.map((address) => (
			<div className='checkbox direct-address-checkbox' key={address}>
				<label htmlFor={`option-${address}`} className='non-trusted'>
					<input
						name={`option-${address}`}
						type='checkbox'
						className='mr-2'
						value={address || ''}
						disabled='true'
					/>
					{'(Not Trusted)' + address + '(HPD)'}
				</label>
			</div>
		));
		const nonTrustedNppesAddress = nonTrustedNppesDirectAddresses?.map((address) => (
			<div className='checkbox direct-address-checkbox' key={address}>
				<label htmlFor={`option-${address}`} className='non-trusted'>
					<input
						name={`option-${address}`}
						type='checkbox'
						className='mr-2'
						value={address || ''}
						disabled='true'
					/>
					{'(Not Trusted)' + address + '(NPPES)'}
				</label>
			</div>
		));
		return (
			<div>
				{hpdNppesaddresses}
				{addresses}
				{nppesAddresses}
				{adtAddresses}
				{nonTrustedHpdNppesAddress}
				{nonTrustedAddresses}
				{nonTrustedNppesAddress}
				<AddressInput
					id={`${this.props.id}-address-input`}
					addAddress={
						(address, successCallback, errorCallback, cancelCallback) => this
							.validateAddress(address, (response) => this.confirmDirectAddress(address, response,
								successCallback, errorCallback, cancelCallback), errorCallback)
					}
				/>
				{this.state.directAddressModal}
			</div>
		);
	}

	render() {
		return (
			<>
				{this.generateCheckBoxes(this.props.directAddresses.concat(this.props.manualAddresses),this.props.nppesDirectAddresses, this.props.hpdNppesDirectAddresses, this.props.nonTrustedDirectAddresses, this.props.nonTrustedNppesDirectAddresses,this.props.nonTrustedHpdNppesDirectAddresses)}
			</>
		);
	}
}
OpportunityQueueAddress.defaultProps = {
	checked: {},
	directAddresses: [],
	manualAddresses: [],
	nppesDirectAddresses:[],
	hpdNppesDirectAddresses:[]
};
OpportunityQueueAddress.propTypes = {
	/**
	 * NPPES demographics
	 */
	nppesDemographic: PropTypes.shape({
		firstName: PropTypes.string,
		lastName: PropTypes.string,
		taxonomies: PropTypes.arrayOf(PropTypes.object)
	}).isRequired,
	/**
	 * Direct addresses
	 */
	directAddresses: PropTypes.arrayOf(PropTypes.string),
	/**
	 * Common Addresses in NPPES & HPD
	 */
	hpdNppesDirectAddresses: PropTypes.arrayOf(PropTypes.string),
	/**
	 * Manually entered addresses
	 */
	manualAddresses: PropTypes.arrayOf(PropTypes.string),
	/**
	 * NPI for provider
	 */
	providerNpi: PropTypes.string.isRequired,
	/**
	 * Sending Facility Identifier
	 */
	sendingFacilityId: PropTypes.string.isRequired,
	/**
	 * Sending Facility Display Name
	 */
	sendingFacilityDisplayName: PropTypes.string.isRequired,
	/**
	 * Provider Subscription Status Document Identifier
	 */
	providerSubscriptionStatusDocumentId: PropTypes.string.isRequired,
	/**
	 * Function that creates a subscription
	 */
	create: PropTypes.func.isRequired,
	/**
	 * Function that checks if the directAddress is trusted and if it's unsubscribed all
	 */
	validateAddress: PropTypes.func.isRequired,
	/**
	 * Id for the queue item
	 */
	id: PropTypes.string.isRequired,
	/**
	 * A callback when an address is (un)checked
	 */
	handleCheck: PropTypes.func.isRequired,

	checked: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.object
	])
};

export default OpportunityQueueAddress;
